const initState = {}

const mapReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CREATE_MAP_SUCCESS':
      console.log('create map success');
      return state;
    case 'CREATE_MAP_ERROR':
      console.log('create map error');
      return state;
    case 'DELETE_MAP_SUCCESS':
      console.log('delete map success');
      return state;
    case 'DELETE_MAP_ERROR':
      console.log('delete map error');
      return state;
    case 'SAVE_MAP_SUCCESS':
      console.log('save map success');
      return state;
    case 'SAVE_MAP_ERROR':
      console.log('save map error');
      return state;
    default:
      return state;
  }
};

export default mapReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/mapReducer.js